module.exports = __webpack_public_path__ + "img/bre9.0258fac7.png";